import type { ApiMagentoDiscount } from "@jti/magento-types";
import type { Translate } from "@jti/ui";

import type { PaymentDiscount } from "../../components/PaymentSummaryView/PaymentSummaryView.types";

export const getFormattedPaymentDiscounts = (
  discounts: ApiMagentoDiscount[] | null | undefined,
  translate: Translate
): PaymentDiscount[] => {
  return (
    discounts?.map(({ label, coupon_code, amount }) => ({
      label: coupon_code?.length ? `${translate("cart.prices.promo_code")} ${label}` : label,
      value: amount.value,
      currency: amount.currency,
    })) ?? []
  );
};
